export enum WageReimbursementStep {    
    PendingApproval = 1,
    Approved = 5,
    Reimbursed = 10,
    Denied = 15
}